const FEATURE_LIST = [
    "FEATURE_FAST_CHECKOUT",
    "FEATURE_GROUP_ORDER",
    "FEATURE_MENU",
];

const useFeatureFlags = () => {
    let result = new Map();
    if (!reactConfig) {
        FEATURE_LIST.forEach((feat) => {
            result.set(feat, true);
        });
    } else {
        const { features } = reactConfig;
        FEATURE_LIST.forEach((feat) => {
            const value = feat in features ? features[feat] : false;
            result.set(feat, value);
        });
    }

    return Object.fromEntries(result);
};

export default useFeatureFlags;
